import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RotatingLogo from "../../Loaders/RotatingLogo";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import MandatorySign from "../../Components/MandatorySign";
import { Dropdown } from "react-bootstrap";
import { phone_prefix } from "../../Components/ContstantValues";
import { PiMagnifyingGlass } from "react-icons/pi";
import SupportedStripeCountries from "../../JSON/SupportedStripeCountries.json";
import SingleLoaderItem from "../../Loaders/SingleLoaderItem";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const BillingInfoStep = ({
    account_id,
    handleStep,
    error,
    setError,
    loadingAddresses,
    billingAddress
}) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const [searchTermPrefix, setSearchTermPrefix] = useState("");
    const [searchTermCountry, setSearchTermCountry] = useState("");
    const [loadingAddress, setLoadingAddress] = useState(false)

    const [formData, setFormData] = useState({
        phonePrefix: "+39",
        phone: "",
        street: "",
        streetNumber: "",
        city: "",
        country: "IT",
    });

    useEffect(() => {
        if (billingAddress) {
            setFormData({
                phonePrefix: billingAddress?.phonePrefix || "+39",
                phone: billingAddress?.phone || "",
                street: billingAddress?.street || "",
                streetNumber: billingAddress?.number || "",
                city: billingAddress?.city || "",
                country: billingAddress?.country || "IT",
            })
        }
    }, [billingAddress])

    const filteredPhonePrefix = phone_prefix.filter((item) => {
        const search = searchTermPrefix.toLowerCase();
        return (
            item.name?.toLowerCase().includes(search) ||
            item.code?.toLowerCase().includes(search) ||
            item.dial_code?.toLowerCase().includes(search)
        );
    });

    const filteredCountries = SupportedStripeCountries.filter((item) => {
        const search = searchTermCountry.toLowerCase();
        return (
            item.value?.toLowerCase().includes(search) ||
            item.label?.toLowerCase().includes(search)
        );
    });

    const updateField = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const phoneRegex = /^\+?[0-9\s\-]{7,15}$/;

    const handleSaveAddress = async () => {
        setError({ message: "", display: false });

        if (!formData.phonePrefix) {
            setError({ message: t.onboarding.personal_info.phone_prefix_required, display: true });
            return;
        }
        if (!formData.phone) {
            setError({ message: t.onboarding.personal_info.phone_required, display: true });
            return;
        }
        if (!phoneRegex.test(formData.phone)) {
            setError({ message: t.onboarding.personal_info.invalid_phone, display: true });
            return;
        }
        if (!formData.street) {
            setError({ message: t.onboarding.personal_info.street_required, display: true });
            return;
        }
        if (!formData.streetNumber) {
            setError({ message: t.onboarding.personal_info.street_n_required, display: true });
            return;
        }
        if (!formData.city) {
            setError({ message: t.onboarding.personal_info.city_required, display: true });
            return;
        }
        if (!formData.country) {
            setError({ message: t.onboarding.personal_info.country_required, display: true });
            return;
        }

        setLoadingAddress(true);

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/save_billing_address`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    phonePrefix: formData.phonePrefix,
                    phone: formData.phone,
                    street: formData.street,
                    streetNumber: formData.streetNumber,
                    city: formData.city,
                    country: formData.country,
                }),
            });

            if (!response.ok) throw new Error("Failed to fetch user session");

            const data = await response.json();
            const status = data.status
            if (status == "OK") {
                navigate("/onboarding/about-you");
            }

            setTimeout(() => setLoadingAddress(false), 2000);
        } catch (error) {
            setLoadingAddress(false)
            setError({ message: "An error occurred while saving the info... retry in a few minutes", display: true })
        }
    };

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.personal_info.billing_title}</p>
                    <p className="step_description fade-in">{t.onboarding.personal_info.billing_subtitle}</p>

                    <div className="complete_profile_step_cont">
                        {loadingAddresses ? (
                            <div className="complete_profile_step_cont_form">
                                <SingleLoaderItem length={4} />
                            </div>
                        ) : (
                            <div className="complete_profile_step_cont_form">
                                <div className="label_input">
                                    <label className="input_label">
                                        {t.onboarding.personal_info.phone} <MandatorySign message={t.onboarding.personal_info.phone_required} />
                                    </label>

                                    <div className="password_eye">
                                        <Dropdown>
                                            <Dropdown.Toggle as="div" className="phone_prefix_btn fade-in">
                                                {formData.phonePrefix}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom_dropdown_menu_phone">
                                                <div className="scrollable_dropdown_cont">
                                                    {filteredPhonePrefix.map((item) => (
                                                        <button
                                                            key={item.code}
                                                            onClick={() => updateField("phonePrefix", item.dial_code)}
                                                            className={`settings_link ${formData.phonePrefix === item.dial_code ? "settings_link_selected" : ""}`}
                                                        >
                                                            {item.dial_code}
                                                        </button>
                                                    ))}
                                                    {filteredPhonePrefix.length == 0 && (
                                                        <button
                                                            className="settings_link"
                                                        >
                                                            {t.no_data_found}
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="drop_filter">
                                                    <span className="drop_filter_icon"><PiMagnifyingGlass /></span>
                                                    <input
                                                        className="drop_filter_input"
                                                        placeholder="Search..."
                                                        value={searchTermPrefix}
                                                        onChange={(e) => setSearchTermPrefix(e.target.value)}
                                                    />
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <input
                                            type="text"
                                            placeholder="Ex. 111 222 33333"
                                            className="register_form_first fade-in"
                                            value={formData.phone}
                                            onChange={(e) => updateField("phone", e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        {t.onboarding.personal_info.street_n} <MandatorySign message={t.onboarding.personal_info.street_required} />
                                    </label>

                                    <div className="password_eye">
                                        <input
                                            type="text"
                                            placeholder="Ex. Market St"
                                            className="register_form_first fade-in"
                                            value={formData.street}
                                            onChange={(e) => updateField("street", e.target.value)}
                                        />

                                        <input
                                            className="register_form_first phone_prefix_btn"
                                            placeholder="N."
                                            value={formData.streetNumber}
                                            onChange={(e) => updateField("streetNumber", e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        {t.onboarding.personal_info.city} <MandatorySign message={t.onboarding.personal_info.city_required} />
                                    </label>

                                    <input
                                        type="text"
                                        placeholder="Ex. San Francisco"
                                        className="register_form_first fade-in"
                                        value={formData.city}
                                        onChange={(e) => updateField("city", e.target.value)}
                                    />
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        {t.onboarding.personal_info.country} <MandatorySign message={t.onboarding.personal_info.country_required} />
                                    </label>

                                    <Dropdown drop="up">
                                        <Dropdown.Toggle as="div" className="register_form_first fade-in">
                                            {formData.country}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="custom_dropdown_menu">
                                            <div className="scrollable_dropdown_cont">
                                                {filteredCountries.map((item) => (
                                                    <button
                                                        key={item.value}
                                                        onClick={() => updateField("country", item.value)}
                                                        className={`settings_link ${formData.country === item.value ? "settings_link_selected" : ""}`}
                                                    >
                                                        {item.label}
                                                    </button>
                                                ))}
                                                {filteredCountries.length == 0 && (
                                                    <button
                                                        className="settings_link"
                                                    >
                                                        {t.onboarding.personal_info.no_countries}
                                                    </button>
                                                )}
                                            </div>

                                            <div className="drop_filter">
                                                <span className="drop_filter_icon"><PiMagnifyingGlass /></span>
                                                <input
                                                    className="drop_filter_input"
                                                    placeholder="Search..."
                                                    value={searchTermCountry}
                                                    onChange={(e) => setSearchTermCountry(e.target.value)}
                                                />
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="steps_btn_cont">
                <button
                    className="steps_btn"
                    onClick={() => handleStep("back", "info")}
                >
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>

                <div>
                    <ErrorMessage err={error} />
                </div>

                <button className="steps_btn fade-in" disabled={loadingAddresses} onClick={handleSaveAddress}>
                    {loadingAddress ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div>
    );
};

export default BillingInfoStep;